<div class="search-container">
    <div class="row">
        <label class="title">{{'LIDS.SEARCH' |translate}}</label>
        <p-button type="button" class="filter-btn" (click)="displaySidebar = true" icon="pi pi-filter"></p-button>
    </div>
</div>

<p-sidebar [(visible)]="displaySidebar" [baseZIndex]="10000">
    <div class="header">{{'LIDS.TITLE_SIDEBAR' |translate}}</div>
    <div class="filters">
            <div class="r-form-group">
                <label class="title">{{'LEADS_MANAGMENT.BUSINESS' |translate}}</label>
                <p-autoComplete class="p-autoComplete" [(ngModel)]="selectedBusiness" [suggestions]="filteredBusinesses"
                    (completeMethod)="filterBusinessNames($event)" field="Name" [dropdown]="true"
                    [placeholder]="'LEADS_MANAGMENT.CHOOSE_BUSINESS'|translate" [forceSelection]="true"
                    [showClear]="true" (onClear)="clearBusinessFilter()" (onSelect)="onBusinessSelected()">
                </p-autoComplete>
            </div>
            <div class="r-form-group">
                <label class="title" for="category">{{'REGISTER.BUSINESS_AERA' | translate}}</label>
                <p-dropdown name="category" [appendTo]="null" [options]="allCategories" [(ngModel)]="selectedCategory"
                    #category="ngModel" optionLabel="label" (onChange)="filterSelectCategory()" [filter]="true"
                    filterBy="label" placeholder="{{'REGISTER.CHOOSE_BUSINESS_AREA' | translate}}" [showClear]="true">
                </p-dropdown>
            </div>
            <div class="r-form-group">
                <label class="title">{{'LIDS.START_DATE' | translate}}</label>
                <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" selectionMode="range" [(ngModel)]="dateRange"
                    [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()"
                    (onSelect)="filterCreatedDate()" (onClickOutside)="filterCreatedDate()">
                </p-calendar>
            </div>
        </div>
</p-sidebar>
 <div style="text-align: center;" class="r-form-group totalRecords">{{totalRecords}} {{'ROULETTE.LIDS'|translate}}</div>

<div class="cards-container">
    <app-lid-card-mobile *ngFor="let lid of lids$ | async" [currentLid]="lid" [columns]="columns">
    </app-lid-card-mobile>
</div>
<p class="noData" *ngIf="!returnTotalRecords">{{ 'READONLY_TABLE.NO_DATA_FOUND'|translate }}</p>
<app-paging *ngIf="returnTotalRecords" [totalRecords]="totalRecords" [numRecordsToPage]="numRowsInPage"
    (currentPageChanged)="createRequest($event)"></app-paging>